import _ from 'lodash';

export function getFieldValueByLang<T extends Record<string, any>>(obj: T | undefined, lang: string) {
    let _lang: string | undefined = lang;
    let value = obj?.[_lang as keyof T];

    if (!_.isObject(obj)) return { value, lang: _lang };

    // 如果根据当前语言无法取到对应的值，则默认取第一个值
    if (!value) {
        [_lang] = Object.keys(obj);
        value = obj[_lang];
    }

    return {
        value: _.cloneDeep(value),
        lang: _lang,
    };
}
